export default __webpack_public_path__ + "static/media/smartroute.1bc1ec5b.jpg";